import { createContext } from 'react';
import type { NavigationEngineState } from '@/navigation/NavigationTypes';

export const NavigationContext = createContext<NavigationEngineState | null>(
  null,
);
